export default [

  {
    id: 1,
    firstName: 'Иван',
    lastName: 'Иванов',
    email: 'user1@email.com',
    password: '123',
    authToken: 'b0893289-68cf-47b2-a026-b5bf8739b87a'
  }

]



// WEBPACK FOOTER //
// ./src/server/fixtures/user.js